import { useContext } from "react";
import { UserPreferencesContext } from "../context/UserPreferencesContext";

export const useUserPreferences = () => useContext(UserPreferencesContext);
